import uuid from 'react-uuid'

export const securityHelper = {
  guid
}

function guid() {
  return uuid()
}
